export type ValidationConfigType = typeof ValidationConfig;

export class ValidationConfig {
  public static FIRST_NAME_MAX_LENGTH = 15;
  public static LAST_NAME_MAX_LENGTH = 20;
  public static ADDRESS_1_MAX_LENGTH = 60;
  public static ADDRESS_2_MAX_LENGTH = 10;
  public static ADDRESS_3_MAX_LENGTH = 35;
  public static ZIP_REGEX = /^[\s\S]*$/i;
  public static ZIP_MAX_LENGTH = 5;
  public static CITY_MAX_LENGTH = 40;
  public static COMPANY_MAX_LENGTH = 35;
  public static PHONE_REGEX = /^[ 0-9\\+\\-]*$/;
  public static PHONE_MAX_LENGTH = 20;
}

export class ValidationConfigNL extends ValidationConfig {
  public static ZIP_REGEX = /^[1-9][0-9]{3} (?!sa|sd|ss)[a-z]{2}$/i;
  public static ZIP_MAX_LENGTH = 7;
}

export class ValidationConfigAU extends ValidationConfig {
  public static FIRST_NAME_MAX_LENGTH = 32;
  public static LAST_NAME_MAX_LENGTH = 32;
  public static ADDRESS_1_MAX_LENGTH = 100;
  public static ADDRESS_2_MAX_LENGTH = 50;
  public static ADDRESS_3_MAX_LENGTH = 150;
  public static ZIP_REGEX = /^[0-9]{4,5}$/i;
  public static ZIP_MAX_LENGTH = 5;
  public static CITY_MAX_LENGTH = 50;
  public static COMPANY_MAX_LENGTH = 255;
}

export class ValidationConfigNZ extends ValidationConfig {
  public static ZIP_REGEX = /^[0-9]{4}$/i;
  public static ZIP_MAX_LENGTH = 4;
}

export class ValidationConfigPL extends ValidationConfig {
  public static ZIP_REGEX = /^[0-9]{2}-[0-9]{3}$/;
  public static ZIP_MAX_LENGTH = 6;
}

export class ValidationConfigHU extends ValidationConfig {
  public static ZIP_REGEX = /^[1-9]\d{3}$/;
  public static ZIP_MAX_LENGTH = 4;
}

export class ValidationConfigBE extends ValidationConfig {
  public static ZIP_REGEX = /^[1-9]\d{3}$/;
  public static ZIP_MAX_LENGTH = 4;
}

export class ValidationConfigSE extends ValidationConfig {
  public static ZIP_REGEX = /^[0-9]{3}\s?[0-9]{2}$/;
  public static ZIP_MAX_LENGTH = 6;
}

export class ValidationConfigDE extends ValidationConfig {
  public static ZIP_REGEX = /^[0-9]{5}$/;
  public static ZIP_MAX_LENGTH = 5;
}

export class ValidationConfigAT extends ValidationConfig {
  public static ZIP_REGEX = /^[1-9]{1}\d{3}$/;
  public static ZIP_MAX_LENGTH = 4;
}

export class ValidationConfigMX extends ValidationConfig {
  public static ZIP_REGEX = /^\d{5}$/;
  public static ZIP_MAX_LENGTH = 5;
}

export class ValidationConfigCZ extends ValidationConfig {
  public static ZIP_REGEX = /^\d{3}\s\d{2}$/;
  public static ZIP_MAX_LENGTH = 6;
}
